// Determine if rules have errors
export const checkErrorsInRules = (errors: any) => {
  if (!errors.rules) {
    return false;
  }

  const { rules } = errors;
  const isErrorsInArray = Array.isArray(rules);

  return isErrorsInArray
    ? false
    : !!Object.keys(errors.rules).some((objKey) => {
        // Single rule
        const rule = errors.rules[objKey];

        if (
          (rule.effects && !Array.isArray(rule.effect)) ||
          (rule.conditions && !Array.isArray(rule.conditions))
        ) {
          const effectsErrors = Object.values(rule.effects || []).some(
            (err) => err,
          );
          const conditionsErrors = Object.values(rule.conditions || []).some(
            (err) => err,
          );
          return effectsErrors || conditionsErrors;
        } else {
          const areEffectErrors =
            rule.effects && Array.isArray(rule.effects)
              ? rule.effects?.some((err: any) => {
                  return err;
                })
              : false;
          const areConditionsErrors =
            rule.conditions && Array.isArray(rule.conditions)
              ? rule.conditions?.some((err: any) => {
                  return err;
                })
              : false;

          return areEffectErrors || areConditionsErrors;
        }
      });
};
